import React from 'react';
import { DoubleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/DoubleChainActionIcon';
import { MobilePushIcon } from 'assets/icons/MobilePushIcon';
import { MobilePushIconAlt } from 'assets/icons/MobilePushIconAlt';

export const MobilePush = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: MobilePushIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#0CBFE7'
            }
        },
        opened: {
            icon: MobilePushIconAlt,
            iconProps: { borderColor: '#0CBFE7' }
        },
        warning: {
            icon: MobilePushIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <DoubleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions
    }}/>
}
